import React, { useEffect, useState } from "react";
import Numpad from "../NumPad/NumPad";

const CashPaymentMethod = ({
  total,
  onAmountChange,
  enteredAmountCash,
  remainingAmount,
}: any) => {
  const [givenAmountCash, setGivenAmountCash] = useState<string | null>(null);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Allow the input if it's a valid number or just a dot.
    if (/^\d*\.?\d*$/.test(value)) {
      setGivenAmountCash(value); // Store the raw input value
      if (value !== "") {
        // Only parse and send the value if it's a valid number
        const parsedValue = value;
        onAmountChange(!isNaN(Number(parsedValue)) ? parsedValue : null);
      } else {
        onAmountChange(null); // Handle empty input
      }
    }
  };
  const handleSetTotalAsCash = () => {
    const formattedTotal = total?.toFixed(3);
    setGivenAmountCash(formattedTotal);
    onAmountChange(formattedTotal);
  };
  const handleResetTotalAsCash = () => {
    setGivenAmountCash("0");
    onAmountChange(0);
  };
  useEffect(() => {
    setGivenAmountCash(null);
  }, [total]);
  
  return (
    <div>
      <div className="navbar-item flex-row search-ul navbar-dropdown">
        <div className="nav-item align-self-center search-animated">
          <form
            className="form-inline search-full form-inline search"
            role="search"
          >
            
            <div className="search-bar" style={{ marginBottom: "7px" }}>
              <div className="relative w-full">
                <input
                  type="text"
                  // style={{ width: "80%" }}
                  className="form-control search-form-control ml-lg-auto pr-16" // Add padding to the right for the button
                  placeholder="Espèces"
                  value={
                    typeof enteredAmountCash === "number" &&
                    enteredAmountCash > 0
                      ? enteredAmountCash.toFixed(3)
                      : givenAmountCash ?? ""
                  }
                  onChange={handleAmountChange}
                />
                {/* {!givenAmountCash ? (
                  <button
                    type="button"
                    className="btn btn-success"
                    style={{ background: "#009688", color: "#fff" }}
                    onClick={handleSetTotalAsCash} // Call the handler here
                  >
                    <svg
                      style={{ position: "unset", margin: 0 }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="#ffffff"
                        d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                      />
                    </svg>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-success"
                    style={{ background: "#009688", color: "#fff" }}
                    onClick={handleResetTotalAsCash} // Call the handler here
                  >
                    x
                  </button>
                )} */}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CashPaymentMethod;
